import { render } from "./DashboardRollupRiskBadge.vue?vue&type=template&id=b864589a"
import script from "./DashboardRollupRiskBadge.vue?vue&type=script&lang=js"
export * from "./DashboardRollupRiskBadge.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "b864589a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b864589a', script)) {
    api.reload('b864589a', script)
  }
  
  module.hot.accept("./DashboardRollupRiskBadge.vue?vue&type=template&id=b864589a", () => {
    api.rerender('b864589a', render)
  })

}

script.__file = "src/components/dashboard/DashboardRollupRiskBadge.vue"

export default script